import { render, staticRenderFns } from "./GradesView.vue?vue&type=template&id=d47d8276&"
import script from "./GradesView.vue?vue&type=script&lang=js&"
export * from "./GradesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports